import React from 'react';
import Scrollbar from 'components/base/Scrollbar';

export interface GenericAuditRow {
  [key: string]: string | number | undefined;
}

interface AuditTableProps<T extends GenericAuditRow> {
  data: T[];
}

const AuditTable = <T extends GenericAuditRow>({ data }: AuditTableProps<T>) => {
  if (!data || data.length === 0) {
    return <p className="text-muted">No audit data available.</p>;
  }

  const headers = Object.keys(data[0]);

  return (
    <Scrollbar autoHeight autoHeightMax="100%">
      <table className="table fs-9 text-body mb-0">
        <thead className="bg-body-secondary">
          <tr>
            <th scope="col" style={{ width: 24 }} />
            {headers.map((header, index) => (
              <th key={index} scope="col" className="text-capitalize fw-semibold" style={{ minWidth: 160 }}>
                {header}
              </th>
            ))}
            <th scope="col" style={{ width: 24 }} />
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-bottom"
              style={{
                pageBreakInside: 'avoid',
                breakInside: 'avoid'
              }}
            >
              <td className="border-0" />
              {headers.map((field, colIndex) => (
                <td key={colIndex} className="align-middle">
                  {row[field]}
                </td>
              ))}
              <td className="border-0" />
            </tr>
          ))}
        </tbody>
      </table>
    </Scrollbar>
  );
};

export default AuditTable;
